//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'
import CommentsDialog from './components/CommentsDialog'
import Skypark from '@/api/promotores/skypark.api'

export default {
	components: { ColumnsSelect, SearchInput },
	data() {
		return {
			columns: [
				{ name: 'nombre', label: 'Nombre Completo', field: 'nombre_completo', align: 'left'  },
				{ name: 'email', label: 'Email', field: 'email', align: 'left'  },
				{ name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'left' },
				{ name: 'promotor', label: 'Promotor', field: 'usuario', align: 'left'  },
				{ name: 'desarrollo', label: 'Desarrollo', field: 'desarrollo', align: 'left'  },
				{ name: 'status', label: 'Status', field: 'status', align: 'left', format: this.formatStatus  },
				{ name: 'comentarios', label: 'Comentarios', field: 'comentarios' },
				{ name: 'created_at', label: 'Creado', field: 'created_at', align: 'left'  },
				{ name: 'updated_at', label: 'Actualizado', field: 'updated_at', align: 'left'  },
			],
			data: [],
			visible_columns: [
				'nombre', 'apellidos', 'telefono', 'email', 'desarrollo', 'promotor', 'status', 'comentarios', 'created_at', 'updated_at',
			],
			loading: false,
			filter: null,
		}
	},

	mounted() {
		this.getContacts() 
	},

	methods: {
		async getContacts() {
			try {
				this.loading = true
				this.data = await Skypark.contacts()
			} finally {
				this.loading = false
			}
		},

		formatStatus(status) {
			return ({
				'NEW': 'Nuevo',
				'SIN_LOCALIZAR': 'Imposible de localizar',
				'IN_PROGRESS': 'Interesado',
				'CONDITIONS': 'Con Condicionantes',
				'NO_CALIFICADO': 'No Calificado',
				'BAD_TIMING': 'No por ahora',
				'OPEN_DEAL': 'Negocio abierto',
				'VENTA_GANADA': 'Venta Ganada',
				'VENTA_PERDIDA': 'Venta Perdida',
			})[status] || status
		},

		async openComentariosDialog({ _id, nombre, apellidos, email, comentarios}) {
			this.$q.dialog({
				component: CommentsDialog,
				prospecto_id: _id,
				title: `Comentarios para ${nombre} ${apellidos}`,
				comentarios,
				organizacion_id: 'skypark',
			})
				.onOk((comentario) => {
					comentarios.push(comentario);
				})
		},
	},

}
